import React from 'react';
import { FolderOpen, MousePointerClick, Pencil } from 'lucide-react';
export function SolutionSection() {
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-184">
      <div className="max-w-5xl mx-auto text-center" data-id="element-185">
        <div className="inline-block bg-green-500 text-white font-bold px-6 py-2 rounded-full mb-6 shadow-md" data-id="element-186">
          ✅ LA SOLUCIÓN
        </div>

        <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-6 font-['Oswald'] uppercase" data-id="element-187">
          Pack Completo – El Asombroso Viaje por el Cuerpo Humano
        </h2>

        <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-16" data-id="element-188">
          Un sistema completo de Ciencias Naturales organizado por unidades,
          diseñado para que dejes de improvisar y vuelvas a disfrutar enseñar.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12" data-id="element-189">
          {/* Step 1 */}
          <div className="flex flex-col items-center" data-id="element-190">
            <div className="w-24 h-24 bg-blue-100 rounded-full flex items-center justify-center mb-6 shadow-inner" data-id="element-191">
              <FolderOpen className="w-12 h-12 text-blue-600" data-id="element-192" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-193">
              1. Abrís el material
            </h3>
            <p className="text-gray-500" data-id="element-194">
              Acceso inmediato a todo el contenido organizado.
            </p>
          </div>

          {/* Step 2 */}
          <div className="flex flex-col items-center" data-id="element-195">
            <div className="w-24 h-24 bg-blue-100 rounded-full flex items-center justify-center mb-6 shadow-inner" data-id="element-196">
              <MousePointerClick className="w-12 h-12 text-blue-600" data-id="element-197" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-198">
              2. Elegís el tomo
            </h3>
            <p className="text-gray-500" data-id="element-199">
              Seleccionás la unidad que necesitás enseñar.
            </p>
          </div>

          {/* Step 3 */}
          <div className="flex flex-col items-center" data-id="element-200">
            <div className="w-24 h-24 bg-blue-100 rounded-full flex items-center justify-center mb-6 shadow-inner" data-id="element-201">
              <Pencil className="w-12 h-12 text-blue-600" data-id="element-202" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-203">
              3. Lo aplicás en clase
            </h3>
            <p className="text-gray-500" data-id="element-204">
              Sin estrés y con todo listo para tus alumnos.
            </p>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-gray-200" data-id="element-205">
          <p className="text-2xl font-bold text-gray-800 uppercase tracking-wide" data-id="element-206">
            Sin vueltas. Sin improvisar. Sin perder tiempo.
          </p>
        </div>
      </div>
    </section>;
}